@if (isDblCurrencyActivated && displayComponent()) {
  <sd-html
    [innerClass]="class()"
    [html]="textBeforePrice() + (price() | convertCurrency: sourceCurrencyIsocode())"
    tag="span"
  />
}
